import React from 'react';
import Footer from '../components/Footer';
import './PlaceholderPage.css';

function CoberturaPage() {
  return (
    <div>
      <section className="placeholder-page">
        <div className="placeholder-page__content">
          <h1 className="placeholder-page__title">Nossa Área de Cobertura</h1>
          <p className="placeholder-page__text">
            Em breve você poderá consultar aqui se a nossa conexão já chegou até você.
          </p>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default CoberturaPage;
